<template>
  <div>
      <Row>
        <Col span="3">
          <Content :style="{'height':maxHeight}">
            <el-table ref="table" :data="typeData" highlight-current-row highlight-selection-row :show-header="false"
                      :max-height="maxHeight" :row-class-name="tableRowClassName" @row-click="handleRowClick">
              <el-table-column fixed prop="name" show-overflow-tooltip  max-width="50"/>
            </el-table>
          </Content>
        </Col>
        <Col span="21">
            <DevelopStandardManageList ref="developStandardManageList" :currentRowIndex="currentRowIndex"
                   :type.sync="type" :sex.sync="sex" :standard.sync="standard" :style="{'overflow-y':'auto','box-sizing':'border-box'}"/>
        </Col>
      </Row>
  </div>
</template>
<script>
import DevelopStandardManageList from "./DevelopStandardManageList.vue"
export default {
  name: "DevelopStandardManage",
  components: { DevelopStandardManageList},
  data() {
    return {
      currentRowIndex: 0,
      type: 1,
      sex: 1,
      standard: 1,
      maxHeight: window.innerHeight - 200,
      typeData: [
          {"name":"男童年龄体重（WHO）",type:1,sex:1,standard:1},
          {"name":"男童年龄体重（国标）",type:1,sex:1,standard:2},
          {"name":"男童年龄身高（WHO）",type:2,sex:1,standard:1},
          {"name":"男童年龄身高（国标）",type:2,sex:1,standard:2},
          {"name":"男童身高体重（WHO）",type:3,sex:1,standard:1},
          {"name":"男童身高体重（国标）",type:3,sex:1,standard:2},
          {"name":"女童年龄体重（WHO）",type:1,sex:2,standard:1},
          {"name":"女童年龄体重（国标）",type:1,sex:2,standard:2},
          {"name":"女童年龄身高（WHO）",type:2,sex:2,standard:1},
          {"name":"女童年龄身高（国标）",type:2,sex:2,standard:2},
          {"name":"女童身高体重（WHO）",type:3,sex:2,standard:1},
          {"name":"女童身高体重（国标）",type:3,sex:2,standard:2},
      ],
      listData:[],
    };
  },
  mounted() {
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  watch:{

  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.maxHeight = `${height - 135}px`;
    },
    tableRowClassName(row) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "current-row";
      }
    },
    handleRowClick(row, column, event){
      this.currentRowIndex = row.index;
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.type = row.type;
      this.sex = row.sex;
      this.standard = row.standard;
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
/deep/ .el-table__body tr.current-row>td.el-table__cell, .el-table__body tr.selection-row>td.el-table__cell {background-color: #beffc5;}
/deep/ .el-table .current-row td{background: #beffc5;color: #101010;}
/deep/ .ivu-table .current-row td{background: #beffc5;color: #101010;}
/* 移除外层包裹的伪元素边框 */
/deep/ .el-table::before {height: 0 !important;  /* 底部外边框 */}
/deep/ .el-table__fixed::before,
/deep/ .el-table__fixed-right::before {width: 0 !important;  /* 移除固定列左侧分隔线 */}
/* 清除带有 border 属性的表格边框 */
/deep/ .el-table--border,
/deep/ .el-table--group {border: none !important;  /* 完全移除外框线 */}
/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell {border: none !important;  /* 移除单元格所有边框 */}

</style>
